import React from 'react'
// @ts-ignore no types
import numeral from 'numeral'
// @ts-ignore no types
import { Text, Icon } from '@adc/ui-adc'
import { CombinedListingType } from 'common/context/listing'
import AnalyticsPopupTooltip from 'common/components/popupTooltip'
import { ARV_TOOLTIP_CONTENT } from 'common/statics'

export const getERVRow = (
  listing: CombinedListingType,
  isRedesignEnabled = false
) => {
  const ervValue = listing?.primary_property?.summary?.valuation
  if (!ervValue || !isRedesignEnabled) {
    return null
  }
  const displayedERV =
    typeof ervValue !== 'number' || isNaN(ervValue)
      ? 'Not Available'
      : numeral(ervValue).format()
  return {
    label: (
      <Text color='gray' data-elm-id='erv_label'>
        Est. Resale{' '}
        <span className='u-nowrap'>
          Value{' '}
          <AnalyticsPopupTooltip
            content={ARV_TOOLTIP_CONTENT}
            elmId='arv_popup_tooltip'
            position='top center'
            trigger={<Icon name='info circle' data-elm-id='erv_popup' />}
          />
        </span>
      </Text>
    ),
    value: (
      <Text color='gray' weight='heavy' data-elm-id='erv_value'>
        {displayedERV}
      </Text>
    ),
  }
}
